import React from 'react';
import { Drawer, Button } from 'components';
import { CloseOutlined } from '@ant-design/icons';
import { ContactInfoFieldKeyType } from 'typings/form';
import { ContactPersonCard } from './ContactPersonCard';
import { ContactPersonData } from 'components/common/contactPerson/contactPersonCard';
import styles from './styles.module.scss';

interface ContactPersonDrawerProps {
  visible: boolean;
  onClose: () => void;
  contactPersons: ContactPersonData[];
  toggleExpandPerson: (personId: string) => void;
  isPersonExpanded: (personId: string) => boolean;
}

export const ContactPersonDrawer: React.FC<ContactPersonDrawerProps> = ({
  visible,
  onClose,
  contactPersons,
  toggleExpandPerson,
  isPersonExpanded,
}) => {
  return (
    <Drawer
      title="Contact Person"
      placement="left"
      width={470}
      onClose={onClose}
      closeIcon={null}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      open={visible}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={onClose} type="text" />
      </div>
      <div className={styles.drawer_content}>
        {contactPersons.map((person) => {
          const contactEntries = Object.entries(person.contacts || {}) as [ContactInfoFieldKeyType, string[]][];
          const contactValues = Object.values(person.contacts || {}) as string[][];

          return (
            <ContactPersonCard
              key={person.id}
              person={person}
              contactEntries={contactEntries}
              isPersonExpanded={isPersonExpanded}
              contactValues={contactValues}
              toggleExpandPerson={toggleExpandPerson}
            />
          );
        })}
      </div>
    </Drawer>
  );
};
